<template>
  <div class="search_form_wrap">
    <div class="form_cont">
      <div class="search">
        <input
          v-model="searchedName"
          type="text"
          class="form_input"
          placeholder="마이팩 명, 제품명 검색"
          title="마이팩 명, 제품명 입력"
          @keydown.enter="searchOptionsChange"
        >
        <button
          class="btn_default-b w96"
          @click.prevent="searchOptionsChange"
        >
          검색
        </button>
      </div>
      <div class="sort">
        <select
          v-model="searchedState"
          class="form_select"
          @change="searchOptionsChange"
        >
          <option value="">
            전체
          </option>
          <option :value="key" v-for="(value, key) in requestUserStates" :key="key">
            {{ value }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { REQUEST_USER_STATES } from '@/utils/constants';

export default {
  name: 'MypacksSearch',
  props: {
    requestUserStates: {
      type: Object,
      default: () => ({
        ...REQUEST_USER_STATES,
      }),
    },
  },
  data() {
    return {
      searchedOption: {},
      searchedName: '',
      searchedState: '',

    };
  },
  created() {
    console.log(this);
  },
  methods: {
    searchOptionsChange() {
      this.searchedOption = {
        searchText: this.searchedName,
        searchStatus: this.searchedState,
      };
      this.$emit('search-options-change', this.searchedOption);
    },
  },
};
</script>

<style scoped>

.search input {
  margin-right: 3px;
}

</style>
